import { FC, JSX } from 'react';

import Modal from '@semcore/modal';

import Button from '@/shared/ui/button';

interface IDeleteModalProps {
  visible?: boolean;
  onClose: () => void;
  triggerDelete: () => void;
}

const DeleteModal: FC<IDeleteModalProps> = ({
  visible = false,
  onClose,
  triggerDelete,
}): JSX.Element => {
  return (
    <Modal visible={visible} onClose={onClose}>
      <Modal.Title className="text-center">Delete text block</Modal.Title>
      <div className="flex flex-col gap-6">
        <div className="text-center text-base font-light">
          You can always create it again
        </div>
        <div className="flex items-center gap-4">
          <div className="flex grow" />
          <Button
            variant="primary"
            size="md"
            title="Delete"
            className="bg-red"
            onClick={triggerDelete}
          />
          <Button
            variant="function"
            size="md"
            title="Cancel"
            onClick={onClose}
          />
          <div className="flex grow" />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
